import { AddLine, Button, Dropdown } from 'ui';
import { useCalendarActionsMenu } from '../../hooks';

const AddNew = () => {
  const { items, modals } = useCalendarActionsMenu({ showRequestTelehealthVisit: true });

  return (
    <>
      <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
        <Button icon={<AddLine size="extra-small" />} size="middle" type="primary">
          New
        </Button>
      </Dropdown>
      {modals}
    </>
  );
};

export default AddNew;
